export enum ENotificationPlacement {
    TOPLEFT = 'topLeft',
    TOPRIGHT = 'topRight',
    BOTTOMLEFT = 'bottomLeft',
    BOTTOMRIGHT = 'bottomRight'
}
